import axios from 'axios'

export class PermissaoModulos {
  static async obtemTodos () {
    return axios.get('/modulos')
  }  
}
